import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StickyFooterMobileComponent } from './sticky-footer-mobile.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CartPreviewModule } from '../../cart/preview/cart-preview.module';

@NgModule({
  declarations: [
    StickyFooterMobileComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    CartPreviewModule,
  ],
  exports: [
    StickyFooterMobileComponent,
  ]
})
export class StickyFooterMobileModule { }
